export default {"src":"https://fishbrain.com/_next/static/media/indiana.8ee71ddf.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};